__turbopack_context__.v({
  "accordeon": "style-module-scss-module__uco9RW__accordeon",
  "activator": "style-module-scss-module__uco9RW__activator",
  "applyBtn": "style-module-scss-module__uco9RW__applyBtn",
  "container": "style-module-scss-module__uco9RW__container",
  "content": "style-module-scss-module__uco9RW__content",
  "details": "style-module-scss-module__uco9RW__details",
  "emailButton": "style-module-scss-module__uco9RW__emailButton",
  "inner": "style-module-scss-module__uco9RW__inner",
  "leftSide": "style-module-scss-module__uco9RW__leftSide",
  "opened": "style-module-scss-module__uco9RW__opened",
  "rightSide": "style-module-scss-module__uco9RW__rightSide",
  "text": "style-module-scss-module__uco9RW__text",
  "title": "style-module-scss-module__uco9RW__title",
  "wrapper": "style-module-scss-module__uco9RW__wrapper",
});
